module.exports = [
  {
    path: '/question',
    component: true,
    redirect: '/question/list',
    name: '问题管理',
    children: [
      {
        path: 'list',
        name: '列表',
        component: () => import('@/views/question/list'),
      },
      {
        path: 'form',
        name: '表单',
        component: () => import('@/views/question/form'),
      },
    ]
  },
]


// WEBPACK FOOTER //
// ./src/router/question.js